import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-order-quick-add-account',
    templateUrl: './order-quick-add-account.component.html',
    styleUrls: ['./order-quick-add-account.component.scss'],
    standalone: false
})
export class OrderQuickAddAccountComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
